"use client";

import { Header } from "@/components/shared/public";
import { useTranslations } from "next-intl";

const Head = () => {
  const t = useTranslations("faq.head");

  return <Header title={t("title")} />;
};

export default Head;
